import React from 'react';
import TicketLayout from '../components/ticket/TicketLayout';

/**
 * The staff ticket page - requester, approver, IT staff and administrators -
 * is the one ticket shell now (components/ticket/TicketLayout.js), with its
 * tabs as sub-routes under /tickets/:id. Kept under this name because App.js
 * and the e2e suites have always opened the staff ticket by it.
 */
export default function TicketDetail() {
  return <TicketLayout mode="staff" />;
}
